import { useDispatch } from "react-redux";
import React, { useState, useRef, useEffect } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import TableChartIcon from "@material-ui/icons/TableChart";
import { grey, blue, red, green } from "@material-ui/core/colors";
import RegularButton from "components/CustomButtons/Button";
import { Typography, List, ListItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import { useXlsxControls } from "./hook";
import CardTable from "components/CardTable/CardTable";
import { columns } from "./columns";
import { FileBox } from "./FileBox";
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import ListIcon from "@material-ui/icons/List";
import WarningIcon from "@material-ui/icons/Warning";
import DoneIcon from "@material-ui/icons/Done";
import { animations } from "helpers/animations";
import { DragAndDropBox } from "./DragAndDropBox";
import { cleanXlsxList } from "redux/actions/xlsx/xlsxActions";
import { postXlsmFiles } from "redux/actions/xlsx/xlsxActions";
import { resetXlsxState } from "redux/actions/xlsx/xlsxActions";

const templateUrl = process.env.REACT_APP_XLSX_TEMPLATE_URL;
export const GenerateXMLView = () => {
  const dispatch = useDispatch();
  const { xlsx } = useSelector(({ xlsxReducer }) => xlsxReducer);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { loading, processXLSX } = useXlsxControls();
  const [isDownload, setIsDownload] = useState(false);
  const [open, setOpen] = useToggle();
  const [error, setError] = useState(false);
  const [tempFiles, setTempFiles] = useState([]);
  const {buildCompLoadings} = useSearch()
  const handleCleanXlsxList = () => {
    dispatch(cleanXlsxList());
  };

  const handleReset = () => {
    dispatch(resetXlsxState())
  }
  const handleSubmit = () => {
    const files = xlsx.map((item) => {
      return {
        fileName: item.fileName,
        file: item.file,
        id: item.id,
      };
    });
    dispatch(postXlsmFiles(files, setOpen));
  };
  
  useEffect(() => {
    buildCompLoadings(['loadingXlsx'])
  }, [])

  useEffect(() => {
    let timeout;
    if (isDownload) {
      timeout = setTimeout(() => setIsDownload(false), 5000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isDownload]);

  useEffect(() => {
    const idx = xlsx.findIndex((item) => !item.validFile);
    idx !== -1 ? setError(false) : setError(true);
  }, [xlsx]);
  return (
    <>
      <CardTable
        hasHeader
        title="Generar XML por Permiso"
        icon={<ListIcon />}
        blockBtn
        columns={columns}
        isLoading={isLoadingComp?.loadingXlsx || loading}
        data={xlsx}
        tableContent={
          <DragAndDropBox processXLSX={processXLSX} handle={setTempFiles} />
        }
        hasControl
        controls={
          <>
            {xlsx.length > 0 && 
              <div>
              <RegularButton color="linkedin" onClick={handleReset} style={{marginRight: 8}}>
                Nuevo
              </RegularButton>
                <RegularButton
                color={error ? "success" : "warning"}
                onClick={!error ? handleCleanXlsxList : setOpen}
                >
                {!error ? "Limpiar Lista" : "Generar XML"}
                </RegularButton>
                  </div>
            }

            <RegularButton
              color="info"
              href={templateUrl}
              onClick={() => setIsDownload(true)}
              disabled={isDownload}
            >
              Descargar Plantilla
            </RegularButton>
          </>
        }
      />
      <ModalV2
        open={open}
        onClose={setOpen}
        title="Estas seguro que desea generar los siguientes archivos?"
      >
        <List
          style={{
            maxHeight: 300,
            overflow: "hidden",
            overflowY: "scroll",
          }}
        >
          {xlsx.map((fl) => (
            <ListItem key={fl.id}>
              {fl.fileName}{" "}
              {fl.validFile ? (
                <DoneIcon style={{ color: green[500] }} />
              ) : (
                <WarningIcon style={{ color: red[500] }} />
              )}
            </ListItem>
          ))}
        </List>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            marginTop: 32,
          }}
        >
          <RegularButton onClick={setOpen} color="danger">
            Cancelar
          </RegularButton>
          <RegularButton onClick={handleSubmit} color="info">
            Aceptar
          </RegularButton>
        </div>
      </ModalV2>
    </>
  );
};
